import { IPointsPlan } from "redux/reducers";

export const calculateTotalAmountForPoint = (pointsPlane: IPointsPlan|null) => {
  if (!pointsPlane) {
    return 0;
  }
  return (pointsPlane.amount * (100+pointsPlane.tax)) / 100;
};

export const calculateTaxForPoint = (pointsPlane: IPointsPlan) => {
  return (pointsPlane.amount * pointsPlane.tax) / 100;
};
